var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94336 11.9336C9.37281 12.5077 9.92072 12.9827 10.5499 13.3265C11.1791 13.6703 11.8749 13.8747 12.59 13.9259C13.3052 13.9771 14.0229 13.8739 14.6947 13.6233C15.3665 13.3728 15.9765 12.9806 16.4834 12.4736L19.4834 9.47356C20.3942 8.53055 20.8981 7.26754 20.8867 5.95655C20.8753 4.64557 20.3495 3.39151 19.4225 2.46447C18.4954 1.53743 17.2413 1.01158 15.9304 1.00019C14.6194 0.988797 13.3564 1.49277 12.4134 2.40356L10.6934 4.11356",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9436 9.93351C12.5141 9.35939 11.9662 8.88433 11.337 8.54057C10.7078 8.19682 10.0121 7.9924 9.29691 7.94118C8.58177 7.88996 7.86397 7.99315 7.19221 8.24373C6.52045 8.49432 5.91044 8.88644 5.40356 9.39351L2.40356 12.3935C1.49277 13.3365 0.988797 14.5995 1.00019 15.9105C1.01158 17.2215 1.53743 18.4756 2.46447 19.4026C3.39151 20.3296 4.64557 20.8555 5.95655 20.8669C7.26754 20.8783 8.53055 20.3743 9.47356 19.4635L11.1836 17.7535",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/LinkIcon.c919a72753fabe9378e9f17b40e3040e.svg";
export { ForwardRef as ReactComponent };